import React from "react";
import PropTypes from "prop-types";
import { Link, Redirect } from "react-router-dom";
import styled from "styled-components";
import moment from "moment";

import { A, Block, ContentHolder, H1, LinkButton } from "commons";

import { hasAdviser } from "../../helpers/ContactHelpers";
import { routes } from "../../helpers/RouteHelpers";

export function Welcome({ firstLogin, lastLogin, newsItems, name, adviser }) {
    const isUnreadNews = () => {
        const latestDate = newsItems
            ?.map(item => item.date)
            ?.sort((a, b) => moment(b) - moment(a))[0];
        return latestDate > lastLogin;
    };

    return firstLogin ? (
        <WelcomeMessage data-testid="first-login-welcome" name={name} adviser={adviser} />
    ) : (
        <Redirect to={isUnreadNews() ? routes.client.news() : routes.client.home()} />
    );
}

function WelcomeMessage({ name, adviser }) {
    return (
        <ContentHolder>
            <H1>Good morning {name}</H1>
            <Flexi>
                <WelcomeBlock>
                    <p>Welcome to Nucleus Go</p>
                    <p>Accessing your investments has never been easier.</p>
                    <p>
                        <span>
                            If you have any questions, need assistance or would like to provide us
                            with feedback please
                        </span>
                        <span>
                            {" "}
                            <A href="mailto:client.relations@nucleusfinancial.com">
                                send us a message
                            </A>
                        </span>
                        {hasAdviser(adviser) ? (
                            <span data-testid="contacts-link">
                                {" "}
                                or contact your{" "}
                                <Link to={routes.client.contacts()}>financial adviser</Link>
                            </span>
                        ) : null}
                    </p>
                </WelcomeBlock>
            </Flexi>
            <LinkButton to={routes.client.home()}>Continue</LinkButton>
        </ContentHolder>
    );
}

const Flexi = styled.div`
    display: flex;
    justify-content: center;
`;

export const WelcomeBlock = styled(Block)`
    flex: 0 0 60%;

    @media (max-width: 959px) {
        flex: 0 0 90%;
    }
`;

Welcome.propTypes = {
    adviser: PropTypes.object,
    firstLogin: PropTypes.bool,
    lastLogin: PropTypes.string,
    newsItems: PropTypes.array,
    name: PropTypes.string
};

WelcomeMessage.propTypes = {
    name: PropTypes.string,
    adviser: PropTypes.object
};
